import { Typography } from 'antd';

function renderLabelWithLinks(label, links) {
  const parts = label.split(/\[([^\]]+)\]/g);
  let linkIndex = 0;

  return parts.map((part, index) => {
    if (index % 2 === 1) {
      const href = links[linkIndex++];
      return (
        <Typography.Link key={`link-${index}`} href={href} target='_blank' rel='noopener noreferrer'>
          {part}
        </Typography.Link>
      );
    }

    return <span key={`text-${index}`}>{part}</span>;
  });
}

export default renderLabelWithLinks;
